export const TYPE_CONFIRM = {
  DELETE_USER: "DELETE_USER",
  CHANGE_ROLE: "CHANGE_ROLE",
};
